// extracted by mini-css-extract-plugin
module.exports = {"icons":"SearchBar_icons__1Se7J","search":"SearchBar_search__22_iH"};